import { useState } from 'react'

interface ILazyFetchParams {
  url: string
  method: string
  headers?: HeadersInit
  body?: any
}

interface ILazyFetchResult {
  loading?: boolean
  status?: number
  statusText?: string
  data?: any
  error?: any
}

const useLazyFetch = () => {
  const [result, setResult] = useState<ILazyFetchResult>({
    loading: false,
  })

  const lazyFetch = async (params: ILazyFetchParams) => {
    setResult((old) => ({
      ...old,
      loading: true,
    }))

    await executeFetch(params)

    setResult((old) => ({
      ...old,
      loading: false,
    }))
  }

  const executeFetch = async ({
    url,
    method,
    headers,
    body,
  }: ILazyFetchParams) => {
    const init: RequestInit = { method }
    if (headers) init.headers = headers
    if (body) init.body = body

    const response = await fetch(url, init)
    const text = await response.text()

    try {
      const json = JSON.parse(text)

      if (response.status >= 200 && response.status <= 299)
        setResult((old) => ({
          ...old,
          data: json,
          error: undefined,
        }))
      else {
        setResult((old) => ({
          ...old,
          data: undefined,
          error: json,
        }))
      }
    } catch {
      setResult((old) => ({
        ...old,
        data: undefined,
        error: text,
      }))
    }

    setResult((old) => ({
      ...old,
      status: response.status,
      statusText: response.statusText,
    }))
  }

  return [lazyFetch, result] as const
}

export { useLazyFetch }
export type { ILazyFetchParams, ILazyFetchResult }
